import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    CircularProgress
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';

import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'expensesTypeName', label: 'Expenses Type Name', minWidth: 150 },
    {
        id: 'amount',
        label: 'Amount',
        minWidth: 70
    },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 170
    },
    {
        id: 'createdDate',
        label: 'Created Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'updatedBy',
        label: 'Updated By',
        minWidth: 170
    },
    {
        id: 'updatedDate',
        label: 'Updated Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'remark',
        label: 'Remark',
        minWidth: 170
    }
];

function createData(count, name, amount, created, remark) {
    return { count, name, amount, created, remark };
}

const rows = [
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark'),
    createData('1', 'package name', 'amount', '5/15/2023', 'remark')
];

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [expenseDetails, setExpenseDetails] = useState({});

    const fetchExpenseDetails = async () => {
        try {
            const res = await axiosInstance.get(`/Expenses/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setExpenseDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (open) {
            fetchExpenseDetails();
        }
    }, [open]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Customer Profile
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '300px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Expense Type Name : <span style={{ fontWeight: 600 }}>{expenseDetails.expensesTypeName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Amount : <span style={{ fontWeight: 600 }}>{expenseDetails.amount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{expenseDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {expenseDetails.createdDate &&
                                            `${expenseDetails.createdDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + expenseDetails.createdDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{expenseDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {expenseDetails.updatedDate &&
                                            `${expenseDetails.updatedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + expenseDetails.updatedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Remark : <span style={{ fontWeight: 600 }}>{expenseDetails.remark}</span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const ExpensesRecords = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [expensesTypes, setExpensesTypes] = useState([]);
    const [usernames, setUsernames] = useState([]);
    const [userNameAvailability, setUserNameAvailability] = useState([]);
    const [checkUserNameAvailability, setCheckUserNameAvailability] = useState({});
    const [expensesRecords, setExpensesRecords] = useState([]);

    const [filterExpensesFrom, setFilterExpensesFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterExpensesTo, setFilterExpensesTo] = useState(dayjs());
    const [filterExpensesType, setFilterExpensesType] = useState('');

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //fetch expenses types start
    const fetchExpensesTypes = async () => {
        try {
            const res = await axiosInstance.get('/ExpensesType', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setExpensesTypes(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch expenses types end

    //fetch expenses UserNameAvailability start
    const fetchExpensesUserNameAvailability = async () => {
        try {
            const res = await axiosInstance.get('/Expenses/UserNameAvailability', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCheckUserNameAvailability(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch expenses UserNameAvailability end

    //fetch username start
    const fetchUserName = async () => {
        try {
            const res = await axiosInstance.get(`/Usernames`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsernames(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //fetch username start
    const UserNameAvailability = async () => {
        try {
            const res = await axiosInstance.get(`/UserNameAvailability`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUserNameAvailability();
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    // fetch expenses records start
    const [fetchExpenseLoading, setFetchExpenseLoading] = useState();
    const fetchExpenses = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        if (!filterExpensesFrom.isValid() || !filterExpensesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let expensesURL = `/Expenses/All?createdDateFrom=${filterExpensesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterExpensesTo.format(
            'YYYY-MM-DD'
        )}`;
        if (filterExpensesType !== '') {
            expensesURL += `&expensesTypeID=${filterExpensesType}`;
        }

        setFetchExpenseLoading(true);
        try {
            const res = await axiosInstance.get(expensesURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setExpensesRecords(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchExpenseLoading(false);
        }
    };
    // fetch expenses records end

    //insert expenses start
    const InsertExpense = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [insertExpenseType, setInsertExpenseType] = useState('');
        const [insertExpenseAmount, setInsertExpenseAmount] = useState(0);
        const [insertExpenseRemark, setInsertExpenseRemark] = useState('');
        const [insertExpenseUsername, setInsertExpenseUsername] = useState('');

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
        const [usernameSetting, setUsernameSetting] = useState(false);
        const [insertExpenseLoading, setInsertExpenseLoading] = useState(false);

        useEffect(() => {
            if (checkUserNameAvailability?.isInputDisabled) {
                setUsernameSetting(true);
                setInsertExpenseUsername(checkUserNameAvailability.defaultUserName);
            }
        }, [checkUserNameAvailability]);

        const submitInsertExpense = async () => {
            if (insertExpenseType === '' || parseFloat(insertExpenseAmount) === 0) {
                warningAlert('Please fill all required fields.');
                return;
            }
            setInsertBtnDisabled(true);
            setInsertExpenseLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Expenses',
                    {
                        expensesTypeID: insertExpenseType,
                        amount: parseFloat(insertExpenseAmount),
                        remark: insertExpenseRemark,
                        userName: insertExpenseUsername
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Expense created successfully.');
                    handleClose();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertBtnDisabled(false);
                setInsertExpenseLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Insert Expense
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertExpenseLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Insert Expense
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Username :
                                            </Typography>
                                            <Select
                                                disabled={checkUserNameAvailability?.isInputDisabled}
                                                displayEmpty
                                                value={insertExpenseUsername}
                                                onChange={(e) => setInsertExpenseUsername(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Username
                                                </MenuItem>

                                                {usernames?.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.userID} key={index}>
                                                        {item.userName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Expense Type Name :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={insertExpenseType}
                                                onChange={(e) => setInsertExpenseType(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Expense Type
                                                </MenuItem>
                                                {expensesTypes.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertExpenseAmount}
                                                onChange={(e) => setInsertExpenseAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Remark :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={insertExpenseRemark}
                                                onChange={(e) => setInsertExpenseRemark(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertExpense()}
                                disabled={insertBtnDisabled}
                            >
                                Create
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert expenses end

    //update customer start
    const UpdateEpense = ({ expense }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [updateExpenseType, setUpdateExpenseType] = useState(expense.expensesTypeID);
        const [updateExpenseAmount, setUpdateExpenseAmount] = useState(expense.amount);
        const [updateExpenseRemark, setUpdateExpenseRemark] = useState(expense.remark);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateExpenseLoading, setUpdateExpenseLoading] = useState(false);

        const submitUpdateExpense = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            setUpdateExpenseLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/Expenses',
                    {
                        expensesID: expense.id,
                        expensesTypeID: updateExpenseType,
                        amount: updateExpenseAmount,
                        remark: updateExpenseRemark
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 200) {
                    successAlert('Updated expense successfully.');
                    fetchExpenses();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateExpenseLoading(false);
            }
        };
        return (
            <div>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateExpenseLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Customer Profile
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Expense Type Name :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateExpenseType}
                                                onChange={(e) => setUpdateExpenseType(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="" disabled>
                                                    Select Expense Type
                                                </MenuItem>
                                                {expensesTypes.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateExpenseAmount}
                                                onChange={(e) => setUpdateExpenseAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Remark :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={updateExpenseRemark}
                                                onChange={(e) => setUpdateExpenseRemark(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateExpense()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </div>
        );
    };
    //update customer end

    //expenses table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {expensesRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <>
                                                    <TableCell key={column.id} align={column.align}>
                                                        {column.format && typeof value === 'number' ? column.format(value) : value}
                                                    </TableCell>
                                                </>
                                            );
                                        })}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <ViewDetailsModal id={row.id} />
                                                <UpdateEpense expense={row} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={expensesRecords.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //expenses table end

    useEffect(() => {
        setLoading(false);

        Promise.all([fetchUserName(), fetchExpensesUserNameAvailability(), fetchExpensesTypes(), fetchExpenses()]).catch((error) => {
            console.error('An error occurred:', error);
        });
    }, []);

    return (
        <Grid container item xs={12}>
            <InsertExpense />

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterExpensesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterExpensesFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterExpensesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterExpensesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Expenses Type :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterExpensesType}
                            onChange={(e) => setFilterExpensesType(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Expense Type
                            </MenuItem>
                            {expensesTypes.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => fetchExpenses()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
            </Grid>

            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchExpenseLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default ExpensesRecords;
